import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Anvesh Photography</h3>
            <p>Professional photography services for all your special moments. We capture memories that last a lifetime.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📧 info@anveshphotography.com</p>
            <p>📱 +91 7337470117</p>
            <p>📍Gachibowli, Hyderabad </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Anvesh Photography. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
